import { ROUTES } from "src/utils/constants/routes";
import { isEmpty } from "@groww-tech-pvt/ella";
import { AOF_STATUS, DATA_TYPE, JOURNEY_TYPES, ONBOARDING_FLOW_SCREENS, SEARCH_PARAMS } from "core/constants";
import { useCosmos } from "core/hooks/useCosmos";
import useOnboardingStore from "core/store";
import { useCallback, useEffect, useRef } from "react";
import { getSearchParams } from "core/hooks/useGetParam";
import { useNavigateToRoute } from "core/hooks/useOnboardingRouter";
import { getDigilockerParams } from "core/utils/digilockerParamCache";
import { useUserDataStore } from "src/utils/store/UserData";

export const useCosmosController = () => {

  const { activeScreen, currentDataType, setActiveScreen, isOnbDataLoading } = useOnboardingStore();
  const { userData } = useUserDataStore();
  const isUserStockOnboarded = userData?.aof_status === AOF_STATUS.COMPLETED;
  const { navigateToRoute } = useNavigateToRoute();
  const initiateRef = useRef(false);

  const { journeyType, digio_doc_id, status, success } = getSearchParams();

  const handleCosmosSuccess = useCallback(() => {
    setActiveScreen(ONBOARDING_FLOW_SCREENS.ONBOARDING_PENDING_SCREEN);
  }, [setActiveScreen]);

  const { initiateCosmosFlow } = useCosmos({ handleCosmosSuccess, journeyType: (journeyType as string) });
  const digiStatus = status || success;

  // Kickstart cosmos if progress not yet initialized
  useEffect(() => {
    if (initiateRef.current) return;
    initiateRef.current = true;
    checkUserStockOnboardingStatus();
  }, [])

  const checkUserStockOnboardingStatus = () => {
    if (isUserStockOnboarded && (isEmpty(journeyType) || journeyType === JOURNEY_TYPES.MAIN_ONBOARDING)) {
      setActiveScreen(ONBOARDING_FLOW_SCREENS.SUCCESS_SCREEN);
    } else {
      performActionBasisDataTypeOnRedirection();
    }
  };

  const performActionBasisDataTypeOnRedirection = () => {
    const cached = getDigilockerParams();
    const digilockerParamPresent = !isEmpty(cached);

    if (digilockerParamPresent) {
      navigateToRoute(ROUTES.ONBOARDING, {
        journeyType: cached?.[SEARCH_PARAMS.JOURNEY_TYPES] ?? journeyType ?? JOURNEY_TYPES.MAIN_ONBOARDING,
        dataType: cached?.[SEARCH_PARAMS.DATA_TYPE] ?? DATA_TYPE.PROOF_OF_ADDRESS_FRONT,
        status: digiStatus,
        digio_doc_id: digio_doc_id,
      });
      if (cached?.[SEARCH_PARAMS.DATA_TYPE] === DATA_TYPE.PROOF_OF_ADDRESS_FRONT) {
        setActiveScreen(ONBOARDING_FLOW_SCREENS.DIGILOCKER);
      } else if (cached?.[SEARCH_PARAMS.DATA_TYPE] === DATA_TYPE.ACCOUNT_FORM) {
        setActiveScreen(ONBOARDING_FLOW_SCREENS.ESIGN);
      }
      return;
    } else {
      initiateCosmosFlow();
    }
  }


  // Handle screen navigation when activeScreen changes
  useEffect(() => {

    if (activeScreen && !digio_doc_id && !isEmpty(journeyType)) {

      navigateToRoute(ROUTES.ONBOARDING, {
        journeyType: journeyType,
        dataType: currentDataType ?? null,
      });
    }
  }, [activeScreen, currentDataType]);

  return {
    activeScreen,
    isOnbDataLoading
  }
}
